import { AlertTriangle, CheckCircle2, MapPin } from 'lucide-react';

import { Badge } from '@/_components';

import { AddressBlock, RecommendedAddressBlock } from './address-blocks';
import type { EnteredAddressSnapshot } from './address-blocks';

import type { AddressValidationResponse } from '../../shared';

type ConfirmContentProps = {
  enteredAddress: EnteredAddressSnapshot | null;
  result: AddressValidationResponse;
  hasRecommended: boolean;
};

export function ConfirmContent({ enteredAddress, result, hasRecommended }: ConfirmContentProps) {
  return (
    <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
      {enteredAddress && (
        <section className="border-c-border rounded-xl border-2 p-4">
          <div className="mb-2 flex items-center gap-2">
            <MapPin className="text-c-card-muted h-4 w-4" />
            <h6 className="text-base font-semibold">You Entered</h6>
          </div>
          <AddressBlock
            line1={enteredAddress.address1}
            line2={enteredAddress.address2}
            cityStateZip={[enteredAddress.city, enteredAddress.state, enteredAddress.postalCode]
              .filter(Boolean)
              .join(', ')}
            country={enteredAddress.country}
          />
        </section>
      )}
      {hasRecommended ? (
        <section className="border-success bg-success/5 rounded-xl border-2 p-4">
          <div className="mb-2 flex items-center gap-2">
            <CheckCircle2 className="text-success h-5 w-5" />
            <h6 className="text-base font-semibold">USPS Verified</h6>
            <Badge type="success" as="base" size="xs" className="bg-success text-white">
              RECOMMENDED
            </Badge>
          </div>
          <RecommendedAddressBlock result={result} />
        </section>
      ) : (
        <section className="border-c-border rounded-xl border-2 p-4">
          <div className="mb-2 flex items-center gap-2">
            <AlertTriangle className="text-warning h-4 w-4" />
            <h6 className="text-base font-semibold">Recommended</h6>
          </div>
          <p className="text-c-card-muted text-sm">
            No recommended address was returned. Please edit your address and try again.
          </p>
        </section>
      )}
    </div>
  );
}
